import CustomToolTip from '../CustomToolTip/CustomToolTip';

export default function InfoToolTip({ text, position, containerStyle, style }) {
  return (
    <CustomToolTip element={text} containerStyle={containerStyle} position={position} style={style}>
      <img style={style} src="/assets/images/icon-info.svg" alt="" />
    </CustomToolTip>
  );
}
